import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-41">
      {label && <label className="mb-1.5 block text-sm font-medium text-gray-700" data-id="element-42">
          {label}
        </label>}
      <div className="relative" data-id="element-43">
        <select className={`appearance-none flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-shadow pr-8 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-44">
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-45">
              {opt.label}
            </option>)}
        </select>
        <ChevronDown className="absolute right-3 top-3 h-4 w-4 text-gray-400 pointer-events-none" data-id="element-46" />
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-47">{error}</p>}
    </div>;
}